var mq = window.matchMedia( "(max-width: 767px)" );
if (mq.matches) {
    var flktySub = new Flickity(  document.querySelector(".mobile-blog"), {
        contain:true,
         pageDots : false,
         adaptiveHeight: true,
         prevNextButtons: false,
        cellAlignment:"left",
         draggable:true,
         resize: false,
           autoPlay : false
       
       });
}
 

